import { useState } from "react";
import useBrowserMode from "./useBrowserMode";

interface IuseVoiceSearch {
  onNoMatch?: () => void;
  onError?: () => void;
  onSuccess?: (result: string) => void;
}

const errorMsg = () => {
  alert("Hubo un error con el micrófono.");
};

const noMatchMsg = () => {
  alert("Lo siento, no te entendí.");
};

const useVoiceSearch = (config?: IuseVoiceSearch) => {
  const { isBrowser, window } = useBrowserMode();
  if (!isBrowser)
    return {
      newVoiceSearch: () => null,
      searchVoiceResult: "",
      isListening: false,
    };
  const [searchVoiceResult, setSearchVoiceResult] = useState<string>("");
  const [isListening, setIsListening] = useState<boolean>(false);
  var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  var recognition = new SpeechRecognition();

  recognition.continuous = false;
  recognition.lang = "es-ES";
  recognition.interimResults = false;
  recognition.maxAlternatives = 1;
  recognition.onspeechend = () => recognition.stop();
  recognition.onnomatch = () =>
    config?.onNoMatch ? config.onNoMatch() : noMatchMsg();
  recognition.onerror = () => (config?.onError ? config.onError() : errorMsg());
  recognition.onresult = function (event) {
    let result = event.results[0][0].transcript;
    result = result.replaceAll(/[¿?¡!.,]+/g, "");
    setIsListening(false);
    setSearchVoiceResult(result);
    config?.onSuccess && config.onSuccess(result);
  };

  const newVoiceSearch: () => void = () => {
    recognition.start();
    setIsListening(true);
  };

  return {newVoiceSearch, searchVoiceResult, isListening};
};

export default useVoiceSearch;
